import { PLAY_MODES, getCurrentTimestamp } from "../Constants.js";

export default class BrazilianCheckers {
  constructor(params) {
    //..
  }

  static isLocValid = (loc) => {
    return (loc.row < 8 && loc.row >= 0 && loc.col < 8 && loc.col >= 0)
  }

  static clearCellSelectionValue = (value) => {
    if(value < 10) {
      return value;
    } else {
      //keep minusing the 10 (added for selection purpose
      let newValue = value - 10;
      return this.clearCellSelectionValue(newValue)
    }
  }

  static getCellValue = (params) => {
    let {
      row,
      col,
      board
    } = params;
    
    let pieceValue = board[row][col];
    pieceValue = this.clearCellSelectionValue(pieceValue) // clearing 10 (added for selection purposes on client side)
    return pieceValue;
  }

  static generatePossibleLocs = (params) => {
    let {
      piece,
      pieceValue,
      board,
    } = params;

    pieceValue = (pieceValue !== undefined) ? pieceValue : this.getCellValue({ ...piece, board });
    let loc1 = null; //forward-left
    let loc2 = null; //forward-right
    let loc3 = null; //backward-left
    let loc4 = null; //backward-right
    const locs = [];

    if(pieceValue === 1) {
      //generate locs for a player's pawn
      loc1 = {
        row: piece.row + 1,
        col: piece.col - 1,
        forward: true,
        direction: "fl",
      }

      loc2 = {
        row: piece.row + 1,
        col: piece.col + 1,
        forward: true,
        direction: "fr",
      }

      loc3 = {
        row: piece.row - 1,
        col: piece.col - 1,
        forward: false,
        direction: "bl",
      }

      loc4 = {
        row: piece.row - 1,
        col: piece.col + 1,
        forward: false,
        direction: "br",
      }

    } else if(pieceValue === 2) {
      //generate locs for an opponent's pawn
      loc1 = {
        row: piece.row - 1,
        col: piece.col - 1,
        forward: true,
        direction: "fl",
      }

      loc2 = {
        row: piece.row - 1,
        col: piece.col + 1,
        forward: true,
        direction: "fr",
      }

      loc3 = {
        row: piece.row + 1,
        col: piece.col - 1,
        forward: false,
        direction: "bl",
      }

      loc4 = {
        row: piece.row + 1,
        col: piece.col + 1,
        forward: false,
        direction: "br",
      }

    } else if(pieceValue === 3) {
      //generate locs for a player's king
      loc1 = {
        row: piece.row + 1,
        col: piece.col - 1,
        forward: true,
        direction: "fl",
      }

      loc2 = {
        row: piece.row + 1,
        col: piece.col + 1,
        forward: true,
        direction: "fr",
      }

      loc3 = {
        row: piece.row - 1,
        col: piece.col - 1,
        forward: false,
        direction: "bl",
      }

      loc4 = {
        row: piece.row - 1,
        col: piece.col + 1,
        forward: false,
        direction: "br",
      }
    } else if(pieceValue === 4) {
      //generate locs for an opponent's king
      loc1 = {
        row: piece.row - 1,
        col: piece.col - 1,
        forward: true,
        direction: "fl",
      }

      loc2 = {
        row: piece.row - 1,
        col: piece.col + 1,
        forward: true,
        direction: "fr",
      }

      loc3 = {
        row: piece.row + 1,
        col: piece.col - 1,
        forward: false,
        direction: "bl",
      }

      loc4 = {
        row: piece.row + 1,
        col: piece.col + 1,
        forward: false,
        direction: "br",
      }
    } else {
      // invalid pieceValue
      
    }

    if(loc1 && this.isLocValid(loc1)) {
      locs.push(loc1);
    }

    if(loc2 && this.isLocValid(loc2)) {
      locs.push(loc2);
    }

    if(loc3 && this.isLocValid(loc3)) {
      locs.push(loc3);
    }

    if(loc4 && this.isLocValid(loc4)) {
      locs.push(loc4);
    }

    return locs;
  }

  static getNextLocInDiagonal = (loc, prevLocValue) => {
    
    let nextLoc = null;
    let locValue = prevLocValue; //restructure, note here locValue is a value for the original piece
    if(locValue === 1 || locValue === 3) {
      //for player
      if(loc.direction === 'fl') {
        nextLoc = {
          row: loc.row + 1,
          col: loc.col - 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'fr') {
        nextLoc = {
          row: loc.row + 1,
          col: loc.col + 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'bl') {
        nextLoc = {
          row: loc.row - 1,
          col: loc.col - 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'br') {
        nextLoc = {
          row: loc.row - 1,
          col: loc.col + 1,
          direction: loc.direction,
        };
      }

    } else if(locValue === 2 || locValue === 4) {
      //for opponent
      if(loc.direction === 'fl') {
        nextLoc = {
          row: loc.row - 1,
          col: loc.col - 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'fr') {
        nextLoc = {
          row: loc.row - 1,
          col: loc.col + 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'bl') {
        nextLoc = {
          row: loc.row + 1,
          col: loc.col - 1,
          direction: loc.direction,
        };
      } else if(loc.direction === 'br') {
        nextLoc = {
          row: loc.row + 1,
          col: loc.col + 1,
          direction: loc.direction,
        };
      }
    }


    if(nextLoc && this.isLocValid(nextLoc)) {
      return nextLoc;
    } else {
      return null;
    }
    
  } 

  static getNextPiecePositions = (params) => {
    //this gets probable positions with type, path and jumps for the selected piece on the given board
    /*
    position = {
      final: {row, col},
      paths: [ {row, col} ],
      isCapture: true/false
    }
    */
    let {
      board,
      piece,
      calledBySelf
    } = params;

    let positions = [];
    let processedLocs = [];
    let possibleLocs = this.generatePossibleLocs({ piece, board })
    

    const isLocProcessed = (loc, processorLoc) => {
      let isProcessed = false;
      processedLocs.forEach((item, i) => {
        if(processorLoc && loc && item.processorLoc && item.loc) {
          if((item.loc.row === loc.row && item.loc.col === loc.col)) { //ignoring processorLoc
            isProcessed = true;
          }
        }
        
      })

      return isProcessed;
    }

    const positionCreator = (loc, isCapture = false, parentLoc = null, capturedPiece = null, processorLoc = null, isKing = false) => {
      //creates and returns a positions, then adds the position and processedLoc
      if(isCapture) {
        if(parentLoc) {
          //if parentLoc is already one of the position's final, then add it to paths and remove it's position
          let parentPosition = null;
          let parentPositionIndex = -1;

          positions.forEach((item, i) => {
            if(item.final.row === parentLoc.row && item.final.col === parentLoc.col) {
              parentPosition = {...item};
              parentPositionIndex = i;
            }
          })

          if(parentPosition && Number(parentPositionIndex) >= 0) {
            //remove the parent position but place it in paths
            //positions.splice(parentPositionIndex, 1); to be done at the end
            const position = {
              final: { ...loc },
              paths: [...parentPosition.paths, { ...parentPosition.final }],
              isCapture,
              capturedPieces: [ ...parentPosition.capturedPieces, capturedPiece],
            };
      
            processedLocs.push({ loc, processorLoc });
            positions.push(position);
            return position;

          } else {
            //just do the normal way, fallback, rarely to no occurence though
            const position = {
              final: { ...loc },
              paths: [],
              isCapture,
              capturedPieces: [capturedPiece],
            };
      
            processedLocs.push({ loc, processorLoc });
            positions.push(position);
            return position;
          }

        } else {
          const position = {
            final: { ...loc },
            paths: [],
            isCapture,
            capturedPieces: [capturedPiece],
          };
    
          processedLocs.push({ loc, processorLoc });
          positions.push(position);
          return position;
        }
      } else {

        //if not capture check if it has parent
        if(parentLoc) {
          //if it has parent only add it if it's capture, but here it is not a capture so discard it
          //position discarded
          //moded for king support
          //is not capture but has parent, now check if parent was capture. If parent was capture make it a capture also
          //taking captured pieces (no paths) from parent
          if(isKing) {
            //get parent position
            let parentPosition = null;
            let parentPositionIndex = -1;

            positions.forEach((item, i) => {
              if(item.final.row === parentLoc.row && item.final.col === parentLoc.col) {
                parentPosition = {...item};
                parentPositionIndex = i;
              }
            })

            

            if(parentPosition && parentPosition.isCapture) {
              //get nextloc in diagonal for the parentPosition
              let pieceValue = this.getCellValue({ board, ...piece });
              let parentNextLocInDiagonal = this.getNextLocInDiagonal(parentPosition.final, pieceValue);

              if(parentNextLocInDiagonal && parentNextLocInDiagonal.row === loc.row && parentNextLocInDiagonal.col === loc.col) {
                //create a position coz it's on same direction as the parent capture
                //create position
                const position = {
                  final: { ...loc },
                  isCapture: true,
                  paths: [],
                  capturedPieces: [...parentPosition.capturedPieces]
                }

                processedLocs.push({ loc, processorLoc });
                positions.push(position);
                return position;
              }

              
            }
          }

        } else {
          //just add it
          const position = {
            final: { ...loc },
            paths: [],
            isCapture,
            capturedPieces: [],
          };
    
          processedLocs.push({ loc, processorLoc });
          positions.push(position);
          return position;
        }
        
      }
      
      processedLocs.push({ loc, processorLoc }); //safety, fallback for skipped locs
    }
    
    const locsProcessor = (loc, parentLoc = null, processorLoc = null) => {
      //processes suggested loc and creates a position if the loc meets conditions 
      
      let locValue = this.getCellValue({ board, ...loc });
      let pieceValue = this.getCellValue({ board, ...piece });

      if(pieceValue > 2) {
        //logic for kings
        if(!isLocProcessed(loc, processorLoc)) {
        
          if(locValue === 0){
            //loc is empty, create position here if it's a king or check direction first if it's a pawn
            //create position, it's king. Also check for more positions in this direction (diagonal)
            let _position = positionCreator(loc, false, parentLoc, null, processorLoc, true);
            let nextLocInDiagonal = this.getNextLocInDiagonal(loc, pieceValue);

            if(_position && _position.isCapture) {
              //locsProcessor(nextLocInDiagonal, _position.final, loc); //change parentLoc
              let morePossibleLocs = this.generatePossibleLocs({ board, pieceValue, piece: {row: _position.final.row, col: _position.final.col} });
              morePossibleLocs.forEach((moreLoc, i) => {
                locsProcessor(moreLoc, _position.final, loc);
              });
            } else {
              if(nextLocInDiagonal) {
                locsProcessor(nextLocInDiagonal, parentLoc, loc);
              } else {
                return;
              }
            }

            
            return 
          } else if(locValue > 0) {
            //probably a capture, so confirm first if it is
            //check if it belongs to the other player
            if(
              (pieceValue === 1 && (locValue === 2 || locValue === 4)) ||
              (pieceValue === 2 && (locValue === 1 || locValue === 3)) ||
              (pieceValue === 3 && (locValue === 2 || locValue === 4)) ||
              (pieceValue === 4 && (locValue === 1 || locValue === 3))
            ) {
              //belongs to the other player
              //check if the next cell after this is empty in the loc direction(diagonel)
              let nextLocInDiagonal = this.getNextLocInDiagonal(loc, pieceValue);
  
              if(nextLocInDiagonal) {
                let nextLocInDiagonalValue = this.getCellValue({ ...nextLocInDiagonal, board });
  
                if(nextLocInDiagonalValue === 0) {
                  //capture confirmed here we'll have to start again with nextLocInDiagonal but add loc to processedLocs
                  processedLocs.push({ loc, processorLoc });
                  let _position = positionCreator(nextLocInDiagonal, true, parentLoc, loc, processorLoc, true);
                  let morePossibleLocs = this.generatePossibleLocs({ board, pieceValue, piece: {row: nextLocInDiagonal.row, col: nextLocInDiagonal.col} });
                  morePossibleLocs.forEach((moreLoc, i) => {
                    locsProcessor(moreLoc, nextLocInDiagonal, loc);
                  });

                  return;
                } else {
                  //capture blocked
                  //add to processedLocs and return
                  processedLocs.push({ loc, processorLoc });
                  return;
                }
              } else {
                //nextLocInDiagonal is not valid
                //add to processedLocs and return
                processedLocs.push({ loc, processorLoc });
                return;
              }
            } else {
              //does not belong to the othe player
              //add to processedLocs and return
              processedLocs.push({ loc, processorLoc });
              return;
            }
          }
        } else {
          return; //ending the fn coz this loc was already processed
        }
      } else {
        //logic for pawns
        //.....
        if(!isLocProcessed(loc, processorLoc)) {
        
          if(locValue === 0){
            //loc is empty, create position here if it's a king or check direction first if it's a pawn
            if(loc.forward) {
                  
              //only create a position if it's forward move ()
              let _position = positionCreator(loc, false, parentLoc, null, processorLoc);
              return;
            }

          } else if(locValue > 0) {
            //probably a capture, so confirm first if it is
            //check if it belongs to the other player
            if(
              (pieceValue === 1 && (locValue === 2 || locValue === 4)) ||
              (pieceValue === 2 && (locValue === 1 || locValue === 3)) ||
              (pieceValue === 3 && (locValue === 2 || locValue === 4)) ||
              (pieceValue === 4 && (locValue === 1 || locValue === 3))
            ) {
              //belongs to the other player
              //check if the next cell after this is empty in the loc direction(diagonel)
              let nextLocInDiagonal = this.getNextLocInDiagonal(loc, pieceValue);
  
              if(nextLocInDiagonal) {
                let nextLocInDiagonalValue = this.getCellValue({ ...nextLocInDiagonal, board });
  
                if(nextLocInDiagonalValue === 0) {
                  //capture confirmed here we'll have to start again with nextLocInDiagonal but add loc to processedLocs
                  processedLocs.push({ loc, processorLoc });
                  let _position = positionCreator(nextLocInDiagonal, true, parentLoc, loc, processorLoc);
                  let morePossibleLocs = this.generatePossibleLocs({ board, pieceValue, piece: {row: nextLocInDiagonal.row, col: nextLocInDiagonal.col} });
                  morePossibleLocs.forEach((moreLoc, i) => {
                    locsProcessor(moreLoc, nextLocInDiagonal, loc);
                  });
                  
                  return;
                } else {
                  //capture blocked
                  //add to processedLocs and return
                  processedLocs.push({ loc, processorLoc });
                  return;
                }
              } else {
                //nextLocInDiagonal is not valid
                //add to processedLocs and return
                processedLocs.push({ loc, processorLoc });
                return;
              }
            } else {
              //does not belong to the othe player
              //add to processedLocs and return
              processedLocs.push({ loc, processorLoc });
              return;
            }
          }
        } else {
          return; //ending the fn coz this loc was already processed
        }
        //.....
      }

      processedLocs.push({ loc, processorLoc }); //safety to protect locs from being processed Twice
      
    }

    possibleLocs.forEach((_loc, i) => {
      locsProcessor(_loc, null, { row: piece.row, col: piece.col });
    });

    const cleanPositions = (positions) => {
      //this removes duplicates of positions, restricts to longest jumps and capture only if available

      let isThereCapture = false;
      let longestCaptureLength = 0;


      //remove duplicates first
      const pBatch1 = positions.filter((_position, _index) => {
        let isDuplicate = false;
        positions.forEach((item, i) => {
          item.paths.forEach((_path) => {
            if(_path.row === _position.final.row && _path.col === _position.final.col) {
              isDuplicate = true;
            }
          })
        })

        if(!isDuplicate) {
          return true;
        } else {
          return false;
        }
      })

      //check if there's a capture
      pBatch1.forEach((_position, _positionIndex) => {
        if(_position.isCapture) {
          isThereCapture = true;

          if(_position.capturedPieces.length > longestCaptureLength) {
            longestCaptureLength = _position.capturedPieces.length;
          }
        }
      })

      if(isThereCapture) {
        if(longestCaptureLength > 0) {
          //return those moves with number of captured pieces equal to longestCapturedLength
          const pBatch3 = pBatch1.filter((item, i) => {
            return (item.capturedPieces.length === longestCaptureLength);
          })

          return pBatch3;
        } else {
          //only return captures
          const pBatch2 = pBatch1.filter((item, i) => {
            return item.isCapture;
          })

          return pBatch2;
        }
      } else {
        return pBatch1;
      }
    }

    let piecePossiblePositions = cleanPositions(positions);

    if(calledBySelf) {
      //console.log("here 1");
      return piecePossiblePositions;
    } else {
      //console.log("here 2");
      //get positions for other pieces of this player then compare if there is a eater somewhere
      const otherPiecesPossiblePositions = [];
      board.forEach((row, rowIndex) => {
        row.forEach((col, colIndex) => {
          let pieceValue = this.getCellValue({ board, ...piece });
          let otherPieceValue = board[rowIndex][colIndex];
          let otherPiece = { row: rowIndex, col: colIndex };
          if(
              this.clearCellSelectionValue(otherPieceValue) === this.clearCellSelectionValue(pieceValue) || 
              this.clearCellSelectionValue(otherPieceValue) === (this.clearCellSelectionValue(pieceValue) + 2) || 
              this.clearCellSelectionValue(otherPieceValue) === (this.clearCellSelectionValue(pieceValue) - 2)
            ) {
            //check player pieces
            let otherPiecePositions = this.getNextPiecePositions({ board, piece: otherPiece, calledBySelf: true, })
            otherPiecesPossiblePositions.push(...otherPiecePositions);
          }
        })
      })

      //analyze ppositions
      let isThereCaptureInOtherPieces = false;
      let maxCaptureLengthInOtherPieces = 0;
      let pieceCaptureLength = 0;

      //check for captures in other pieces and get maxCapture Length
      otherPiecesPossiblePositions.forEach(_position => {
        if(_position.isCapture) {
          isThereCaptureInOtherPieces = true;

          if(_position.capturedPieces.length > maxCaptureLengthInOtherPieces) {
            maxCaptureLengthInOtherPieces = _position.capturedPieces.length;
          }
        }
      })

      //get piece capture length
      piecePossiblePositions.forEach(_position => {
        if(_position.isCapture) {
          if(_position.capturedPieces.length > pieceCaptureLength) {
            pieceCaptureLength = _position.capturedPieces.length
          }
        }
      })

      if(isThereCaptureInOtherPieces) {
        //console.log("There is a piece that can capture");
        //check if capture length for the selected piece is greater or equal to maxCaptureLengthInOtherPieces
        if(pieceCaptureLength >= maxCaptureLengthInOtherPieces) {
          //console.log("Can capture long");
          return piecePossiblePositions;
        } else {
          //console.log("Cannot capture");
          return [] //return empty array showing that this piece can not move (kula ndefu lazima)
        }
      } else {
        //console.log("No other capture was found");
        return piecePossiblePositions;
      }
    }

  }

  static processMove = (params) => {
    //server-side-only
    return new Promise(async (resolve, reject) => {
      let {
        selectedPiece,
        selectedPosition,
        database,
        playMode,
        gameData
      } = params;

      let noCaptureMoves = gameData.noCaptureMoves + 1;

      if(selectedPiece && selectedPosition) {
        const boardState = JSON.parse(gameData.boardData).board;
        const oldBoardState = {...boardState};

        //remove captured pieces if any
        if(selectedPosition.isCapture) { //be careful
          //reset noCaptureMoves 
          noCaptureMoves = 0;
          if(selectedPosition.capturedPieces && selectedPosition.capturedPieces.length > 0) {
            selectedPosition.capturedPieces.forEach((item, i) => {
              boardState[item.row][item.col] = 0;
            })
          }
        }

        //update piece position (and value) in board state
        const selectedPieceValue = this.getCellValue({ ...selectedPiece, board: oldBoardState });
        let selectedPieceNewValue = selectedPieceValue;

        //....check if this piece can be crowned
        if(selectedPieceValue === 1 || selectedPieceValue === 2) {
          if(selectedPieceValue === 1) {
            //checking crowning for player piece
            ///..check if any path reached to king
            let anyPathReachedKing = false;
            selectedPosition.paths.forEach((_path) => {
              if(_path.row === 7) {
                anyPathReachedKing = true;
              }
            })

            if(selectedPosition.final.row === 7 || anyPathReachedKing) {
              selectedPieceNewValue = 3; //crowning
            }

          } else if(selectedPieceValue === 2) {
            //checking crowning for opponent piece
            ///..check if any path reached to king
            let anyPathReachedKing = false;
            selectedPosition.paths.forEach((_path) => {
              if(_path.row === 0) {
                anyPathReachedKing = true;
              }
            })

            if(selectedPosition.final.row === 0 || anyPathReachedKing) {
              selectedPieceNewValue = 4; //crowning
            }
          }
        }

        boardState[selectedPiece.row][selectedPiece.col] = 0; //removing the piece from prev position
        boardState[selectedPosition.final.row][selectedPosition.final.col] = selectedPieceNewValue; //placing it on a new position with new value

        


        //switch players
        let currentPlayer = null;
        if(gameData.currentPlayer === gameData.playerId) {
          currentPlayer = gameData.opponentId;
        } else if(gameData.currentPlayer === gameData.opponentId) {
          currentPlayer = gameData.playerId;
        }

        //reset timer
        const sessionTimer = (process.env.PLAYER_SESSION_DURATION_IN_MIN * 60) + getCurrentTimestamp();
        

        if(currentPlayer) {
          //update database
          const boardData = {
            ...JSON.parse(gameData.boardData),
            board: boardState,
          };

          //..
          if(playMode === PLAY_MODES.LOCAL) {
            //use lovefield database
          } else {
            //use mysql
            database.execute(
              "UPDATE games SET boardData = ?, currentPlayer = ?, sessionTimer = ?, noCaptureMoves = ? WHERE ( id = ?)",
              [ JSON.stringify(boardData), currentPlayer, sessionTimer, noCaptureMoves, gameData.id ]
            ).then(() => {
              resolve(true);
            }).catch((error) => {
              reject("Database server error");
            })
          }
          //..
        } else {
          reject("Invalid player");
        }

      } else {
        reject("Invalid move");
      }
    })
  }

  static initialize = (params) => {
    //server-side-only
    return new Promise(async (resolve, reject) => {
      
      let {
        gameData,
        database,
        playMode,
      } = params;

      
  
      const boardData = {
        //0 = empty cell
        //1 = cell with player piece
        //2 = cell with opponent piece
        //3 = cell with player king
        //4 = cell with opponent king
        board: [
          [1, 0, 1, 0, 1, 0, 1, 0],
          [0, 1, 0, 1, 0, 1, 0, 1],
          [1, 0, 1, 0, 1, 0, 1, 0],
          [0, 0, 0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0, 0, 0],
          [0, 2, 0, 2, 0, 2, 0, 2],
          [2, 0, 2, 0, 2, 0, 2, 0],
          [0, 2, 0, 2, 0, 2, 0, 2],
        ],
      }
      //set currentPlayer
      const currentPlayer = gameData.playerId;
  
      //now update database
      if(playMode === PLAY_MODES.LOCAL) {
        //use lovefield database
      } else {
        //use mysql
        database.execute(
          "UPDATE games SET boardData = ?, currentPlayer = ? WHERE ( id = ?)",
          [ JSON.stringify(boardData), currentPlayer, gameData.id ]
        ).then(() => {
          resolve(true);
        }).catch((error) => {
          reject("Database server error");
        })
      }
      
    })

  }
}
